import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { buyers, images } from '../data/content';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(() => Math.floor(Math.random() * buyers.length));
  const [visible, setVisible] = useState(false);
  const [minutes, setMinutes] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timer: number;
    const show = () => {
      setIndex(i => (i + 1 + Math.floor(Math.random() * 3)) % buyers.length);
      setMinutes(1 + Math.floor(Math.random() * 12));
      setVisible(true);
      timer = window.setTimeout(hide, VISIBLE_FOR);
    };
    const hide = () => {
      setVisible(false);
      timer = window.setTimeout(show, GAP);
    };
    timer = window.setTimeout(show, FIRST_DELAY);
    return () => window.clearTimeout(timer);
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed inset-x-3 bottom-[88px] z-50 flex sm:inset-x-auto sm:left-5 sm:bottom-24" data-id="element-248" data-mp="117o4bxc1p544">
      <AnimatePresence data-id="element-249" data-mp="1fuhbgfbev4l8">
        {visible && !dismissed && <motion.div role="status" initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-2xl ring-1 ring-brand-100 sm:w-80" data-id="element-250" data-mp="1awz7l3c93fk3">
            <img src={images.deck} alt="" className="h-12 w-12 shrink-0 rounded-lg bg-cream object-contain" data-id="element-251" data-mp="s4n1q6me1w57" />
            <div className="min-w-0 text-[13px] leading-snug" data-id="element-252" data-mp="28mki1vgffz8n">
              <p className="text-ink" data-id="element-253" data-mp="23kbniunwop4f">
                <strong data-id="element-254" data-mp="23nhao4cz5gxi">{buyer.name}</strong> from <strong data-id="element-255" data-mp="2ap2zp6tk2k9l">{buyer.country}</strong>
              </p>
              <p className="text-muted" data-id="element-256" data-mp="2aqntuvbyk16x">just purchased the Apometry Practice Deck™</p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] font-semibold text-cta-dark" data-id="element-257" data-mp="2fltfru5d1fv0">
                <CheckCircle2Icon className="h-3 w-3" aria-hidden="true" data-id="element-258" data-mp="2kniov490vjgg" />
                Verified · {minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-muted hover:bg-brand-50" aria-label="Close notification" data-id="element-259" data-mp="1ryv1n34pqk09">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-260" data-mp="21u6hxpvrrza4" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}